/**
 * @file Home.style.js
 * Exports Home component styles.
 */

export default theme => ({
  button: {
    marginTop: `${theme.spacing.unit * 3}px`,
    marginRight: theme.spacing.unit
  }
});



// WEBPACK FOOTER //
// ./src/pages/Home/Home.style.js